import PropTypes from 'prop-types';

import ButtonBase from './ButtonBase';

const typeStyles = {
  primary: 'link-primary',
  secondary: 'link-secondary',
  subtle: 'link-subtle',
  tertiary: 'link-tertiary',
  github: 'link-github',
  gitlab: 'link-gitlab',
  bitbucket: 'link-bitbucket',
};

const LinkButton = ({ children, disabled, href, type, ...rest }) => {
  const style = typeStyles[type] || '';

  return disabled ? (
    <ButtonBase className={style} disabled onClick={() => {}} {...rest}>
      {children}
    </ButtonBase>
  ) : (
    <a className={style} href={href} {...rest}>
      {children}
    </a>
  );
};

LinkButton.propTypes = {
  children: PropTypes.node.isRequired,
  disabled: PropTypes.bool,
  href: PropTypes.string.isRequired,
  type: PropTypes.oneOf(Object.keys(typeStyles)).isRequired,
};

LinkButton.defaultProps = {
  disabled: false,
};

export default LinkButton;
